import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { getMaintenanceSettings } from './admin';
import { stripHtml } from '../utils/validation';
import logger from '../utils/logger';

const FEEDBACK_ALLOWED_CATEGORIES = ['bug', 'hata', 'geliştirme', 'geri bildirim'];
const FEEDBACK_MESSAGE_MAX_LENGTH = 5000;

/**
 * Geri bildirim gönder (doğrudan Firestore'a yazar)
 * Cloud Function "internal" hatası alternatifi: artık Functions yerine Firestore kullanılıyor.
 *
 * @param {string} category - Kategori (bug, hata, geliştirme, geri bildirim)
 * @param {string} message - Kullanıcı mesajı
 * @param {string|null} userEmail - Kullanıcı email (opsiyonel)
 * @param {string|null} userId - Kullanıcı uid (opsiyonel)
 * @returns {Promise<Object>} { success, feedbackId, message }
 */
export const sendFeedback = async (category, message, userEmail = null, userId = null) => {
  const maintenance = await getMaintenanceSettings();
  if (maintenance.success && maintenance.data?.enabled) {
    throw new Error('Site şu an bakımda. Geri bildirim gönderilemiyor.');
  }

  const raw = typeof message === 'string' ? message.trim() : '';
  if (!raw || raw.length > FEEDBACK_MESSAGE_MAX_LENGTH) {
    throw new Error(
      raw.length > FEEDBACK_MESSAGE_MAX_LENGTH
        ? `Mesaj en fazla ${FEEDBACK_MESSAGE_MAX_LENGTH} karakter olabilir.`
        : 'Mesaj gerekli.'
    );
  }
  const trimmed = stripHtml(raw).trim().slice(0, FEEDBACK_MESSAGE_MAX_LENGTH);
  if (!trimmed) {
    throw new Error('Mesaj gerekli.');
  }

  const cat = typeof category === 'string' ? category.trim() : '';
  if (!FEEDBACK_ALLOWED_CATEGORIES.includes(cat)) {
    throw new Error('Geçersiz kategori.');
  }

  const payload = {
    category: cat,
    message: trimmed,
    userEmail: userEmail && typeof userEmail === 'string' ? userEmail.trim() || null : null,
    userId: userId && typeof userId === 'string' ? userId : null,
    createdAt: serverTimestamp(),
    read: false,
    status: 'new'
  };

  try {
    const feedbackRef = await addDoc(collection(db, 'feedback'), payload);
    return {
      success: true,
      feedbackId: feedbackRef.id,
      message: 'Geri bildiriminiz başarıyla gönderildi.'
    };
  } catch (error) {
    logger.error('Geri bildirim gönderme hatası:', error);
    throw error;
  }
};
